module.exports = __webpack_public_path__ + "static/media/lead-phone.bc50517f.png";